import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { ShieldX } from 'lucide-react';

const RequireRole = ({ children, roles, fallback }) => {
  const { user, hasRole } = useAuth();

  const requiredRoles = Array.isArray(roles) ? roles : [roles];
  
  if (!hasRole(requiredRoles)) {
    if (fallback) {
      return fallback;
    }

    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="max-w-md w-full">
          <Alert className="border-red-200 bg-red-50">
            <ShieldX className="h-4 w-4 text-red-600" />
            <AlertDescription className="text-red-800">
              <div className="space-y-2">
                <p className="font-semibold">Erişim Yetkisi Bulunmuyor</p>
                <p className="text-sm">
                  Bu sayfaya erişim için gerekli yetki: {requiredRoles.join(', ')}
                </p>
                <p className="text-sm">
                  Mevcut yetkiler: {user?.org_memberships?.map(m => m.role).join(', ') || 'Tanımlanmamış'}
                </p>
              </div>
            </AlertDescription>
          </Alert>
          
          <div className="mt-4 text-center">
            <Button 
              onClick={() => window.history.back()} 
              variant="outline"
              className="mr-2"
            >
              Geri Dön
            </Button>
            <Button 
              onClick={() => window.location.href = '/app'}
              className="bg-blue-600 hover:bg-blue-700"
            >
              Ana Sayfa
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default RequireRole;